<groundworks-modal>
  <groundworks-modal-header [title]="'Split Project'" [isCancellable]="true" (cancelModal)="cancel()" />
  <groundworks-modal-body>
    <p class="text-muted">
      To Split a project, move product units or totals from the Current Project to a New Project.
    </p>

    <div class="row g-4">
      <div class="col-12 col-xl-6">
        <h5 class="mb-3">Current Project</h5>
        <groundworks-table [data]="currentTable()" />
      </div>
      <div class="col-12 col-xl-6">
        <h5 class="mb-3">New Project</h5>
        <groundworks-table [data]="newTable()" />
      </div>
    </div>

    @if (errorMessage()) {
      <div class="alert alert-danger mb-0 mt-3" role="alert">{{ errorMessage() }}</div>
    }
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
